
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_45_wUa8tAR1BjmlxriPbmkvPheqkwCqzxhJavC__45Mt_45QMeta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/index.vue?macro=true";
import { default as presseozjriyvkCjObjob0vrgoSjFkv6PbBrk7o9sezRqt8T8Meta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/presse.vue?macro=true";
import { default as contactcFi4cZPspHT4iCzaXKeI4kFdG3koaBf4Jlkv_45CzNp7QMeta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/contact.vue?macro=true";
import { default as _91_46_46_46path_93ejHd0vIF_45_45XhHuYrDBiKbZBlP_45HRhQXWgM49b3zQke8Meta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/[...path].vue?macro=true";
import { default as guide_45_91guide_93VGwGits1p6_YbWVRP3h_I90bmOlh8gN5MKRIFwGEc_8Meta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/guide-[guide].vue?macro=true";
import { default as petites_45astuces2xQY0SMcuNiIeoNPSO3vU3SetvLmo8yNi_g5Fjxuc08Meta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/petites-astuces.vue?macro=true";
import { default as index1CalRS4n_45eWrD2ews5UKE3ybwgriB4bAA5Xi1eG39mQMeta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/ressources/index.vue?macro=true";
import { default as indexmXMJ1kJrtXvqoR54uwERDZkgjXgBQ_4500XKMoVm9A0mkMeta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/partenariat/index.vue?macro=true";
import { default as _91slug_93L2dEjQ8tpQSg0Nc1L2sl2ydrzm8y8rRNwbz0KXjNVs8Meta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/ressources/[slug].vue?macro=true";
import { default as indexxQ6kt0bUcm0WF9WMO2KnZomrQop88z0vZva_oaF4ZG0Meta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/collectivite/index.vue?macro=true";
import { default as _91slug_93yzG7BASAyrbjRYZ4ffsVUpXi3NBmds2VzY0vITOqgwIMeta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/partenariat/[slug].vue?macro=true";
import { default as contact_N4tbzxEshc7gr_45Guzz0yEO0Wc14D3HKcyF44Sk6HCIMeta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/collectivite/contact.vue?macro=true";
import { default as tarificationgnkSNC4QM6z7O1cKMyp0IRSj7AakIHamMhl7FWjEw48Meta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/association/tarification.vue?macro=true";
import { default as petit_45dej_45interassociatifT9sVDvkJRNNuxLJ8iNfpvtDJTlVVDtezvfsxhiSaOFcMeta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/petit-dej-interassociatif.vue?macro=true";
import { default as contactdYDqmjniaa3ZtLj7epNJuWGnt70jq2cFTAI1pCY_9v8Meta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/association/reseau/contact.vue?macro=true";
import { default as tarificationVwBCDSPT_sy3tDLjdHOW_45aujEI3ptqoVJjPO9cgqylIMeta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/association/reseau/tarification.vue?macro=true";
import { default as unsubscribetosySBVoovMfJenXOZ3_45CErqwg5s3vzDMJxYuZRHCTAMeta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/campaign/petites-astuces/[id]/unsubscribe.vue?macro=true";
import { default as component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.3_better-sqlite3@12.0.0_db0@0.3.2_be_5fe8dfc28baccba7f736c48cb28ddaeb/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ } from "/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.3_better-sqlite3@12.0.0_db0@0.3.2_be_5fe8dfc28baccba7f736c48cb28ddaeb/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/index.vue")
  },
  {
    name: "presse",
    path: "/presse",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/presse.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/contact.vue")
  },
  {
    name: "path",
    path: "/:path(.*)*",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/[...path].vue")
  },
  {
    name: "guide-guide",
    path: "/guide-:guide()",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/guide-[guide].vue")
  },
  {
    name: "petites-astuces",
    path: "/petites-astuces",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/petites-astuces.vue")
  },
  {
    name: "ressources",
    path: "/ressources",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/ressources/index.vue")
  },
  {
    name: "partenariat",
    path: "/partenariat",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/partenariat/index.vue")
  },
  {
    name: "ressources-slug",
    path: "/ressources/:slug()",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/ressources/[slug].vue")
  },
  {
    name: "collectivite",
    path: "/collectivite",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/collectivite/index.vue")
  },
  {
    name: "partenariat-slug",
    path: "/partenariat/:slug()",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/partenariat/[slug].vue")
  },
  {
    name: "collectivite-contact",
    path: "/collectivite/contact",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/collectivite/contact.vue")
  },
  {
    name: "association-tarification",
    path: "/association/tarification",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/association/tarification.vue")
  },
  {
    name: "petit-dej-interassociatif",
    path: "/petit-dej-interassociatif",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/petit-dej-interassociatif.vue")
  },
  {
    name: "association-reseau-contact",
    path: "/association/reseau/contact",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/association/reseau/contact.vue")
  },
  {
    name: "association-reseau-tarification",
    path: "/association/reseau/tarification",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/association/reseau/tarification.vue")
  },
  {
    name: "campaign-petites-astuces-id-unsubscribe",
    path: "/campaign/petites-astuces/:id()/unsubscribe",
    component: () => import("/home/bas/app_8cd291d6-bdea-4f66-b30d-f7ce7ee0b706/app/pages/campaign/petites-astuces/[id]/unsubscribe.vue")
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/tarification",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/locale",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/nationale",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/nationale/contact",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/remercier-les-benevoles-pourquoi-comment-",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/2",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/3",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/4",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/5",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/6",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/ptite-dej-interassociatif",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/outils",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/conseils",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/tutos",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  },
  {
    name: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQMeta?.name,
    path: "/ressources/3-astuces-pour-transformer-plus-de-visiteurs-en-benevoles-et-augmenter-le-trafic-de-votre-site-internet",
    component: component_45stubqjz5CA6nd7iD2dMbDYOHXpTlmvJkNonQGZGfy9D0ACQ
  }
]